// src/components/AugustPracticeDetail.js
// Intro screen for a single Practice, reached from the Practices library. Design-system
// normalization pass: this is now the last of the seven primary/detail screens (Today, Journey,
// Practices library, Moments, Profile, Practice Detail, Practice Flow) on the shared PageHeader
// (ui/PageHeader.js) — it previously used ui/Header plus hand-rolled eyebrow/title divs. Reuses
// StationEntry's .station-entry-page/.station-entry-wrap (App.css) for the same reason the flow
// screens reuse .practice-screen: one already-full-bleed-correct outer container, PageHeader as
// the first child of the padded/centered inner one, same shape as AugustToday's own screen.
// Premium-refinement pass: dropped the separate Signatural tagline paragraph that used to sit
// between the (also Signatural) title and the description — two consecutive handwritten
// elements read as noise, not premium. practice.tagline still exists in content.js and is still
// used by the Practices library row and Today's Practice card; this screen just no longer
// repeats it. Content model is now: PageHeader (eyebrow, Signatural title) -> description
// (Inter, 1-2 sentences, explains the exercise — PRACTICES[].description, content.js) ->
// primary CTA. Signatural carries only the title here — display typography only, per the
// typography rule.
import React from 'react'
import PageHeader from './ui/PageHeader'
import PrimaryButton from './ui/PrimaryButton'
import AugustTabBar from './AugustTabBar'
import './practices/shared/PracticeHeading.css'
import './AugustPracticeDetail.css'

export default function AugustPracticeDetail({ practice, canBegin, onBegin, onBack, activeTab, onChangeTab, augustTheme, onAugustThemeChange }) {
  if (!practice) return null
  const isLightweight = practice.type === 'lightweight'

  return (
    <div className="station-entry-page" data-city="august">
      <div className="station-entry-wrap station-entry-animate">
        <PageHeader
          eyebrow={isLightweight ? 'Lightweight Practice' : 'Interactive Practice'}
          title={practice.name}
          showBack onBack={onBack}
          augustTheme={augustTheme} onAugustThemeChange={onAugustThemeChange}
        />

        {practice.description && (
          <p className="practice-detail-description">
            {practice.description}
          </p>
        )}

        {canBegin ? (
          <PrimaryButton onClick={onBegin}>
            <span>{isLightweight ? 'Begin' : 'Begin Practice'}</span>
            <span>{isLightweight ? '✦' : '→'}</span>
          </PrimaryButton>
        ) : (
          <p className="practice-detail-soon">
            More on this soon — this Practice is unlocked, and the full experience is still being built.
          </p>
        )}
      </div>
      <AugustTabBar activeTab={activeTab} onChange={onChangeTab} />
    </div>
  )
}
